import { defineStore } from 'pinia'
import axios from '@operis/Config/axios'

export const useWorkerMetadataStore = defineStore('worker-metadata', {
    // NOTE!
    // Due to the metadata implementation server side all values are stored and returned as strings
    // keep this in mind when you're expecting ie a boolean value
    state: () => ({
        // use this library to store and look up "don't show again" state.
        // please store these flags as positive-influence (ie a bool true means _do_ show)
        show_dialogues: {
            // "confirm accepting recommendation" dialog on Roster Optimiser
            operis_accept_recommendation: "1",
            // "confirm rejecting recommendation" dialog on Roster Optimiser
            operis_reject_recommendation: "1",
        },
    }),

    actions: {
        // fetch all metadata from the server and load it into the store
        async fetchMetadata() {
            // @ts-ignore route() is included at the page level using the @routes blade directive
            let url = route('workers.current-worker.metadata.index')
            return axios.get(url)
                .then((response) => {
                    const metadata = response.data

                    // load metadata into the store
                    for (const key in metadata) {
                        // keys can be nested ie show_dialogues.operis_accept_recommendation
                        // so we need to check if the key exists in the show_dialogues object
                        if (key.startsWith('show_dialogues.')) {
                            const subKey = key.replace('show_dialogues.', '')
                            if (Object.prototype.hasOwnProperty.call(this.show_dialogues, subKey)) {
                                this.show_dialogues[subKey] = metadata[key]
                            }
                        }
                        // otherwise, just set the key directly
                        else if (Object.prototype.hasOwnProperty.call(metadata, key)) {
                            this.show_dialogues[key] = metadata[key]
                        }
                    }
                })
                .catch((error) => {
                    console.error('Failed to fetch worker metadata:', error)
                })
        }
    }
})